import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoadingOverlayService } from '../loading-overlay/loading-overlay.service';

@Injectable()
export class LoadingIndicatorInterceptor implements HttpInterceptor {
    private readonly loadingOverlayService = inject(LoadingOverlayService);

    private _totalRequests = 0;
    private _completedRequests = 0;

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        ++this._totalRequests;

        this.loadingOverlayService.startLoading();

        return next
            .handle(req) //
            .pipe(
                finalize(() => {
                    ++this._completedRequests;

                    if (this._completedRequests === this._totalRequests) {
                        this.loadingOverlayService.stopLoading();
                        this._completedRequests = 0;
                        this._totalRequests = 0;
                    }
                }),
            );
    }
}
